import { jsx as _jsx } from "react/jsx-runtime";
const TabTitle = ({ title  })=>/*#__PURE__*/ _jsx("div", {
        "data-testid": "TabTitle",
        children: /*#__PURE__*/ _jsx("span", {
            children: title
        })
    });
export default TabTitle;

//# sourceMappingURL=index.js.map